import { render, staticRenderFns } from "./PCLogin.vue?vue&type=template&id=77de4fa4&scoped=true"
import script from "./PCLogin.vue?vue&type=script&lang=js"
export * from "./PCLogin.vue?vue&type=script&lang=js"
import style0 from "./PCLogin.vue?vue&type=style&index=0&id=77de4fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77de4fa4",
  null
  
)

export default component.exports